import { useEffect, useState } from "react";
import * as tf from "@tensorflow/tfjs";
import coxParameters from "./outcome_dcm.json";
import crtScaler from "../initializations/scaler.json";

const significantDimensions = [0, 4, 5, 7, 8, 9, 10, 11, 12, 14, 15, 16, 18, 21, 22, 24, 25, 26, 29, 30, 31];
const significantSDs = significantDimensions.map((i) => crtScaler.sd[i]);
const significantMeans = significantDimensions.map((i) => crtScaler.mean[i]);

async function getCoxPrediction(significantSliders: Array<number>): Promise<any> {
  return await tf
    .sub(
      1,
      tf.pow(
        coxParameters.baseline_survival,
        tf.exp(tf.dot(tf.tensor1d(coxParameters.coefs), tf.mul(tf.sub(significantSliders, significantMeans), significantSDs)))
      )
    )
    .array();
}

function PredictionDCMOutcome(sliders: number[]): number {
  const significantSliders = significantDimensions.map((i) => sliders[i]);
  const [prob, setProb] = useState<any>([]);

  useEffect(() => {
    getCoxPrediction(significantSliders).then((array) => setProb(Math.round(array * 100)));
  }, significantSliders);

  return prob;
}

export const algorithms: Array<{ text: string; baseValue: number; colors: string[]; probability: { (sliders: number[]): number } }> = [
  {
    text: "Five-year risk of life-threathening ventricular arrhythmias",
    baseValue: 13,
    colors: coxParameters.colors,
    probability: PredictionDCMOutcome,
  },
];
